import api from 'data/api';

//todo change to added lookup
export const loadAdded = api('GET /api/mobile/finance/lookups/added');
